var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightBulbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 6.88867C11.0253 6.88867 7.50293 10.4108 7.50293 14.7404C7.50293 17.621 9.10246 20.2781 11.6196 21.6513V23.2737C11.6196 23.7255 11.9858 24.0916 12.4375 24.0916H18.2448C18.6965 24.0916 19.0627 23.7255 19.0627 23.2737V21.6535C21.5965 20.2857 23.2064 17.6276 23.2064 14.7405C23.2064 10.4108 19.684 6.88867 15.3547 6.88867ZM17.9056 20.4029C17.614 20.5357 17.4267 20.8266 17.4267 21.1472V22.4558H13.2554V21.1472C13.2554 20.8279 13.0695 20.5376 12.7797 20.4043C10.5679 19.3855 9.1387 17.1622 9.1387 14.7404C9.1387 11.3129 11.9271 8.52445 15.3547 8.52445C18.7822 8.52445 21.5706 11.3129 21.5706 14.7404C21.5706 17.166 20.132 19.3887 17.9056 20.4029Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6189 25.1816H13.0933C12.6416 25.1816 12.2754 25.5478 12.2754 25.9995C12.2754 26.4513 12.6415 26.8174 13.0933 26.8174H17.6189C18.0707 26.8174 18.4368 26.4513 18.4368 25.9995C18.4368 25.5478 18.0707 25.1816 17.6189 25.1816Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7045 13.1994H16.1896L13.1687 16.9641C13.0641 17.0789 13.004 17.2303 13 17.3889C12.9988 17.5494 13.0584 17.7039 13.1659 17.8184C13.2733 17.933 13.4199 17.9983 13.5733 18H17.4267C17.5785 17.9992 17.7238 17.9357 17.8312 17.8234C17.9385 17.7112 17.9992 17.5591 18 17.4003C18.0008 17.3213 17.9866 17.243 17.958 17.1698C17.9295 17.0967 17.8873 17.0302 17.8339 16.9744C17.7805 16.9185 17.717 16.8744 17.6471 16.8445C17.5772 16.8147 17.5022 16.7998 17.4267 16.8007H14.7948L17.8203 13.0229C17.9299 12.9111 17.9942 12.7596 18 12.5997C18.0008 12.5207 17.9866 12.4424 17.958 12.3692C17.9295 12.296 17.8873 12.2296 17.8339 12.1737C17.7805 12.1179 17.717 12.0737 17.6471 12.0439C17.5772 12.0141 17.5022 11.9992 17.4267 12H13.7045C13.629 11.9992 13.5541 12.0141 13.4841 12.0439C13.4142 12.0737 13.3507 12.1179 13.2973 12.1737C13.2439 12.2296 13.2017 12.296 13.1732 12.3692C13.1446 12.4424 13.1304 12.5207 13.1312 12.5997C13.1321 12.7585 13.1927 12.9105 13.3 13.0228C13.4074 13.1351 13.5527 13.1985 13.7045 13.1994Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9259 0H16.0741V3.44444H14.9259V0ZM31 12.6296V13.7778L27.5556 13.7778V12.6296H31ZM3.44444 13.7778V12.6296H0V13.7778L3.44444 13.7778ZM25.1438 2.2963L26.0323 3.02342L23.851 5.6891L22.9624 4.96197L25.1438 2.2963ZM5.40446 2.36909L4.59259 3.18095L7.02818 5.61654L7.84005 4.80468L5.40446 2.36909Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.0827,
    y1: 9.94538,
    x2: 20.8679,
    y2: 21.8862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF794D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.857,
    y1: 25.4723,
    x2: 15.06,
    y2: 26.9464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF794D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.095,
    y1: 13.0661,
    x2: 17.5667,
    y2: 17.0371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF794D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 12.989,
    y1: 2.4481,
    x2: 15.7584,
    y2: 14.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF794D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbIcon);
export default __webpack_public_path__ + "static/media/light-bulb-icon.52e03f2b7fd4919f698c67bb89ef81e9.svg";
export { ForwardRef as ReactComponent };